import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./styles.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import Geral from "./Geral";
import Telas from "./Telas";
import Funcoes from "./Funcoes";
import Produtos from "./Produtos";
import Emails from "./Emails";
import Usuarios from "./Usuarios";
import { ListarUsuariosPorGrupoController } from "../../../../Controllers/Geral/Grupos/GruposUsuarioController";
import { usuarioGrupo } from "../../../../Interfaces/Geral/Grupos/GruposUsuarioInterface";
import AcaoEtapa from "./AcaoEtapa";

interface IModalInterface {
    iDGrupo: number;
    updateList: () => void;
}
export function ModalEditarGrupoHeader(groupName: string) {
    return (
        <>
            <Modal.Title
                id="contained-modal-title-vcenter"
                className="card-title"
            >
                <FontAwesomeIcon icon={faArrowRight} className="mr-2" />
                <h3 className="card-label">{groupName}</h3>
            </Modal.Title>
            <div className="card-toolbar">
                <ul
                    className="nav nav-tabs nav-bold nav-tabs-line"
                    role="tablist"
                    id="#GrupoTools"
                >
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#InformacaoGrupo"
                            data-toggle="tab"
                            data-target="#InformacaoGrupo"
                            role="tab"
                        >
                            <span className="nav-icon">
                                <i className="flaticon-squares"></i>
                            </span>
                            <span className="nav-text">Geral</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#GrupoFuncoes"
                            data-toggle="tab"
                            data-target="#GrupoFuncoes"
                        >
                            <span className="nav-icon">
                                <i className="flaticon-attachment"></i>
                            </span>
                            <span className="nav-text">Funções</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#GrupoTelas"
                            data-toggle="tab"
                            data-target="#GrupoTelas"
                        >
                            <span className="nav-icon">
                                <i className="flaticon-web"></i>
                            </span>
                            <span className="nav-text">Telas</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#GrupoProdutos"
                            data-toggle="tab"
                            data-target="#GrupoProdutos"
                        >
                            <span className="nav-icon">
                                <i className="flaticon-home"></i>
                            </span>
                            <span className="nav-text">Produtos</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#GrupoUsuarios"
                            data-toggle="tab"
                            data-target="#GrupoUsuarios"
                        >
                            <span className="nav-icon">
                                <i className="flaticon-user"></i>
                            </span>
                            <span className="nav-text">Usuários</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#GrupoEmailsConta"
                            data-toggle="tab"
                            data-target="#GrupoEmailsConta"
                        >
                            <span className="nav-icon">
                                <i className="flaticon-email"></i>
                            </span>
                            <span className="nav-text">EmailsConta</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#GrupoBloqueioAcao"
                            data-toggle="tab"
                            data-target="#GrupoBloqueioAcao"
                        >
                            <span className="nav-icon">
                                <i className="flaticon-lock"></i>
                            </span>
                            <span className="nav-text">Ação Etapa</span>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}

function ModalEditarGrupo(props: IModalInterface) {
    const [idGrupo, setIdGrupo] = useState(props.iDGrupo);

    const [lstUsuariosPorGrupo, setlstUsuariosPorGrupo] = useState(
        [] as Array<usuarioGrupo>
    );
    const [loading, setLoading] = useState(true);
    function updateUsers(idGrupo: number) {
        ListarUsuariosPorGrupoController(idGrupo).then((response) => {
            setLoading(false);
            setlstUsuariosPorGrupo(response);
        });
    }

    useEffect(() => {
        setIdGrupo(props.iDGrupo);
    }, [props.iDGrupo]);

    useEffect(() => {
        if (idGrupo !== 0) updateModal(idGrupo);
    }, [idGrupo]);

    function updateModal(idGrupo: number) {}

    return (
        <div className="tab-content" id="GrupoTools">
            <div
                className="tab-pane fade active show"
                id="InformacaoGrupo"
                role="tabpanel"
                aria-labelledby="InformacaoGrupo"
            >
                <Geral
                    idGrupo={idGrupo}
                    updateList={props.updateList}
                    updateModal={updateModal}
                    loading={loading}
                    lstUsuariosPorGrupo={lstUsuariosPorGrupo}
                    setLoading={setLoading}
                    setlstUsuariosPorGrupo={setlstUsuariosPorGrupo}
                />
            </div>
            <div
                className="tab-pane fade"
                id="GrupoFuncoes"
                role="tabpanel"
                aria-labelledby="GrupoFuncoes"
            >
                <Funcoes idGrupo={idGrupo} />
            </div>
            <div
                className="tab-pane fade"
                id="GrupoTelas"
                role="tabpanel"
                aria-labelledby="GrupoTelas"
            >
                <Telas idGrupo={idGrupo} />
            </div>
            <div
                className="tab-pane fade"
                id="GrupoProdutos"
                role="tabpanel"
                aria-labelledby="GrupoProdutos"
            >
                <Produtos idGrupo={idGrupo} />
            </div>
            <div
                className="tab-pane fade"
                id="GrupoUsuarios"
                role="tabpanel"
                aria-labelledby="GrupoUsuarios"
            >
                <Usuarios idGrupo={idGrupo} updateUsers={updateUsers} />
            </div>
            <div
                className="tab-pane fade"
                id="GrupoEmailsConta"
                role="tabpanel"
                aria-labelledby="GrupoEmailsConta"
            >
                <Emails idGrupo={idGrupo} />
            </div>
            <div
                className="tab-pane fade"
                id="GrupoBloqueioAcao"
                role="tabpanel"
                aria-labelledby="GrupoBloqueioAcao"
            >
                <AcaoEtapa idGrupo={idGrupo} />
            </div>
        </div>
    );
}
export default ModalEditarGrupo;
